/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as eventService from '../services/eventService'
class ImportEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected_date: "",
            selected_game: 4,
            seriesList: {},
            activeMarkets:[],
            masterData:[],
            changedMarkets:[]
        };
    }
    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },()=>{
            if(name === "selected_date"){
                let date_string = this.formateApiDate(value)
                this.loadEventList(this.state.selected_game,date_string)
            }
        })
    }
    changeGame(game){
        this.setState({"selected_game":game},()=>{
            let date_string = this.formateApiDate(this.state.selected_date)
            this.loadEventList(game, date_string)
        })
    }
    componentDidMount() {
        let date = this.formatPickerDate(new Date())
        this.setState({ selected_date: date }, async() => {
            let date_string = this.formateApiDate(date)
            let activeMarkets = await eventService.getActiveMarkets()
            this.setState({ activeMarkets:activeMarkets})
            eventService.getEventTemplate().then((response)=>{
                this.setState({masterData:response},()=>{
                    this.loadEventList(this.state.selected_game, date_string)
                })
            })
        })
    }
    loadEventList(game,date){
        eventService.getImportEvent(game, date).then(async(res) => {
            if (!!res.seriesList) {
                let marketList = []
                Array.prototype.forEach.call(Object.keys(res.seriesList),(seriesId, i) => {
                    let series = res.seriesList[seriesId]
                    Array.prototype.forEach.call(Object.keys(series.matchList),(evtId, j) => {
                        let event = series.matchList[evtId]
                        let markets = event.marketList.map(mkt => mkt.marketId)
                        marketList = marketList.concat(markets)
                    })
                })
                let marketDatas = await eventService.getMarketsFromIdList(marketList)
                this.setState({ seriesList: res.seriesList, activeMarkets: marketDatas, changedMarkets:[]})
            }
        })
    }
    findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }    
    importEvents(type,id){
        let filteredData = []
        if(type === "series"){
            filteredData = this.state.changedMarkets.filter((mkt,i)=>{
                return mkt.competitionId === id
            })            
        } else{
            filteredData = this.state.changedMarkets.filter((mkt,i)=>{
                return mkt.eventId === id
            })
        }
        let importData = []
        let eventList = filteredData.reduce(function (r, a) {
            r[a.eventId] = r[a.eventId] || [];
            r[a.eventId].push(a);
            return r;
        }, Object.create(null));
        Array.prototype.forEach.call(Object.keys(eventList), (evetId,i)=>{
            let seriesId = eventList[evetId][0].competitionId
            let series = this.state.seriesList[seriesId]
            let event = this.state.seriesList[seriesId].matchList[evetId]
            let data = {
                "eventId": evetId,
                "eventName": event["eventName)"],
                "eventTypeId": this.state.selected_game,
                "eventTypeName": this.state.selected_game===4?"cricket":this.state.selected_game===1?"soccer":"tennis",
                "openDate": event.openData,
                "tvUrl": "",
                "eventStatus": event.eventStatus,
                "competitionId": seriesId,
                "competitionName": series.seriesName,
                "isActive":true,
                "markets": eventList[evetId]
            }
            importData.push(data)
           })
        eventService.importEvents(importData).then(async(res)=>{
            if(!res.isSuccess){
                alert(res.exception.message)
            } else {
                let date_string = this.formateApiDate(this.state.selected_date)
                this.loadEventList(this.state.selected_game,date_string)
            }
        })
    }
    editData(market,field,value,match_id,series_id,marketData){
        let changedMarkets = this.state.changedMarkets
        let marketIndex = this.findWithAttr(changedMarkets,"marketId",market)
        if(marketIndex>-1){
            changedMarkets[marketIndex][field]=value
        } else {
            let newData = {
                marketId:market,
                isDirty:true,
                eventId:match_id,
                competitionId:series_id,
                eventTypeId:this.state.selected_game
            }
            newData =  Object.assign({}, newData, marketData)
            newData[field] = value
            changedMarkets.push(newData)
        }
        this.setState({changedMarkets:changedMarkets})
    }
    formatEventDate(date) {
        var d = new Date(date);
        let dformat = [
            d.getDate() < 10 ? "0" + d.getDate() : d.getDate(),
            (d.getMonth() + 1) < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1),
            d.getFullYear()].join('/') + ' ' +
            [d.getHours() < 10 ? "0" + d.getHours() : d.getHours(),
            d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()].join(':');
        return dformat
    }
    formateApiDate(date) {
        let dateArr = date.split("-")
        return dateArr[0].slice(-2) + dateArr[1] + dateArr[2]
    }
    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }
    render() {
        return (
            <body className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper">
                    <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
                        <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
                        <ul>
                            <li><a href="list-of-clients.html">List of Clients</a></li>
                            <li><a href="#">Market Analysis</a></li>
                            <li><a href="import-event.html">Import Event</a></li>
                            <li>
                                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                                <ul className="list-unstyled collapse" id="homeSubmenu" >
                                    <li><a href="#">Test 1</a></li>
                                </ul>
                            </li>
                            <li>
                                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                                <ul className="list-unstyled collapse" id="home1Submenu" >
                                    <li><a href="#">Test 1</a></li>
                                    <li><a href="#">Test 1</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">Import Event</h5>
                                    <div className="row supermaster mt-3">
                                        <div className="col-12 col-sm-12 col-md-12">
                                            <div className="btn-group btn-group-sm mb-2 event-menu">
                                                <button type="button" onClick={()=>{this.changeGame(4)}} className={this.state.selected_game===4?"btn btn-primary active":"btn btn-primary"}>Cricket </button>
                                                <button type="button" onClick={()=>{this.changeGame(1)}} className={this.state.selected_game===1?"btn btn-primary active":"btn btn-primary"}>Soccer </button>
                                                <button type="button" onClick={()=>{this.changeGame(2)}} className={this.state.selected_game===2?"btn btn-primary active":"btn btn-primary"}>Tennis </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2 import-event">
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <div className="form-group mb-0">
                                                <label for="exampleFormControlSelect1">Date:</label>
                                                <input className="form-control" type="date" name="selected_date" value={this.state.selected_date} onChange={(e) => { this.onChange(e) }} id="FromDate" />
                                           </div>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3">
                                            <div className="form-group mb-0">
                                                <label for="exampleFormControlSelect1">&nbsp;</label>
                                           </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-12 col-sm-12 col-md-12">
                                            {Object.keys(this.state.seriesList).map((series_id, i) => {
                                                let series = this.state.seriesList[series_id]
                                                return (<div className="gray-box mb-3">
                                                    <div className="d-flex">
                                                        <span className="series-title">{series.seriesName}</span>
                                                        <span className="import-btn" onClick={()=>{this.importEvents("series",series_id)}}>Import</span>
                                                    </div>
                                                    {
                                                        Object.keys(series.matchList).map((match_id, j) => {
                                                            let event = series.matchList[match_id]
                                                            return (<>
                                                                <div className="row mb-3">
                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-3 ml-2">
                                                                        <span className="eventname-title"><i className="fa fa-long-arrow-right" aria-hidden="true"></i> {event["eventName)"]}
                                                                            <span className="gray-text"> {this.formatEventDate(event.openData)}</span>
                                                                            <span className="import-btn" onClick={()=>{this.importEvents("event",match_id)}}>Import</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    {
                                                                        event.marketList.map((market, k) => {
                                                                            let mkData = this.state.activeMarkets.filter((mkt,i)=>{
                                                                                return mkt.marketId === market.marketId
                                                                            })
                                                                            if(mkData.length > 0){
                                                                                mkData = mkData[0]
                                                                                mkData.readOnly = true
                                                                            } else {
                                                                                mkData = this.state.changedMarkets.filter((mkt,i)=>{
                                                                                    return mkt.marketId === market.marketId
                                                                                })
                                                                                if(mkData.length > 0){
                                                                                    mkData = mkData[0]
                                                                                }else{
                                                                                    mkData = this.state.masterData.filter((mkt) => {
                                                                                        let mktGame = mkt.eventType === "Cricket" ? 4 : mkt.eventType === "Soccer" ? 1 : 2
                                                                                        return mkt.marketType === market.marketType && mktGame === this.state.selected_game
                                                                                    })
                                                                                    mkData = mkData.length>0?mkData[0]:{}
                                                                                }
                                                                            }
                                                                            mkData.marketTime = market.marketTime
                                                                            mkData.marketStatus = market.status
                                                                            mkData.inPlay = market.inPlay 
                                                                            mkData.competitionName = series.seriesName
                                                                            mkData.eventName = event["eventName)"]
                                                                            return (<div className={(k+1)%4!==0?"col-12 col-sm-6 col-md-6 col-lg-3 mt-2 mt-box bor-r1" : "col-12 col-sm-6 col-md-6 col-lg-3 mt-2 mt-box"}>
                                                                                <div className="text-center">
                                                                                    <span className="status-title">{market.marketType}</span>
                                                                                    <span className="status-name text-green">( {market.status} )</span>
                                                                                </div>
                                                                                <div className="text-center mt-1">
                                                                                    <label className="checkboxx">
                                                                                        <input type="checkbox" checked={mkData.isActive} onChange={()=>{this.editData(market.marketId,"isActive",!mkData.isActive,match_id,series_id,mkData)}} disabled={mkData.readOnly}/>
                                                                                        <span className="checkmark1"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <div className="text-center w-100 " >
                                                                                    <div className="w-48">
                                                                                        <span className="tit1">Min:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.minBet} onChange={(e)=>{this.editData(market.marketId,"minBet",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="100" /></span>
                                                                                    </div>
                                                                                    <div className="w-48">
                                                                                        <span className="tit1">Max:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.maxBet} onChange={(e)=>{this.editData(market.marketId,"maxBet",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="100000" /></span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">Max Profit:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.maxProfit} onChange={(e)=>{this.editData(market.marketId,"maxProfit",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">Pot Limit:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.potLimit} onChange={(e)=>{this.editData(market.marketId,"potLimit",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">MTP:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.mtp} onChange={(e)=>{this.editData(market.marketId,"mtp",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="300000" /></span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">Check Volume:</span>
                                                                                        <span>
                                                                                            <label className="checkboxx">
                                                                                                <input type="checkbox" disabled={mkData.readOnly} onChange={(e)=>{this.editData(market.marketId,"volume",mkData.volume!==null?null:0,match_id,series_id,mkData)}} checked={mkData.volume !== null} />
                                                                                                <span className="checkmark1 mt-6"></span>
                                                                                            </label>
                                                                                        </span>
                                                                                        <span>
                                                                                            <input type="text" disabled={ mkData.volume===null || mkData.readOnly} value={mkData.volume} onChange={(e)=>{this.editData(market.marketId,"volume",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-55" placeholder="100000" />
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">Allow Unmatch Bet:</span>
                                                                                        <span>
                                                                                            <label className="checkboxx">
                                                                                                <input type="checkbox" disabled={mkData.readOnly} checked={mkData.allowLimitOrder} onChange={(e)=>{this.editData(market.marketId,"allowLimitOrder",!mkData.allowLimitOrder,match_id,series_id,mkData)}}/>
                                                                                                <span className="checkmark1 mt-6"></span>
                                                                                            </label>
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className=" w-100 mt-1">
                                                                                    <div>
                                                                                        <span className="tit1">Bet Delay:</span>
                                                                                        <span><input type="number" disabled={mkData.readOnly} value={mkData.betDelay} onChange={(e)=>{this.editData(market.marketId,"betDelay",parseFloat(e.target.value),match_id,series_id,mkData)}} className="form-control d-inline w-60" placeholder="5" /></span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            </>)
                                                        })
                                                    }
                                                </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ImportEvent);